import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const useLovedProperties = (type: string) => {
  const axios = useAxios(type);
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const panel = Number(queryParams.get("panel"));
  const page = Number(queryParams.get("page")) || 1;
  const limit = Number(queryParams.get("limit")) || 10;
  const urlKey = `${t("fav-property-list-api")}?page=${page}&limit=${limit}`;

  const {
    data,
    isLoading,
    isError,
    isSuccess,
    isPlaceholderData,
    error,
    refetch
  } = useQuery({
    queryKey: ["Saved-Properties", page, limit],
    queryFn: async () => {
      const res = await axios.get(urlKey);
      if (Number(page) === 1) {
        localStorage.setItem(
          "SavedPropertyTotal",
          res.data.data[0]?.full_count
        );
      }
      return res.data;
    },
    placeholderData: (previousData) => previousData, // Identity function

    enabled: panel === 2 && window.innerWidth >= 768
  });

  return {
    data: data?.data,
    refetch, // Function to manually refetch the data if needed
    isLoading, // Loading state for when the query is in progress
    isError, // Error state for when the query fails
    isSuccess, // Success state for when the query succeeds
    isPlaceholderData,
    error // Detailed error information if any
  };
};
